import React, { useState } from "react";
import { HomePageExplore } from "../../../Data/CardFilter";
import CourseCard from "./CourseCard";
// import HighlightText from "./HighlightText";

const tabsName = [
  "Bridal Mehendi Design",
  "Madhubani Design",
  "Karwa Chauth Design",
  "Heavy Mehendi Design",
  "Arabic Mehendi Design",
  
];

const ExploreMore = () => {
  const [currentTab, setCurrentTab] = useState(tabsName[0]);
  const [courses, setCourses] = useState(HomePageExplore[0].courses);
  const [currentCard, setCurrentCard] = useState(
    HomePageExplore[0].courses[0].heading
  );

  const setMyCards = (value) => {
    setCurrentTab(value);
    const result = HomePageExplore.filter((course) => course.tag === value);
    setCourses(result[0].courses);
    setCurrentCard(result[0].courses[0].heading);
  };

  return (
    <div className="relative lg:h-[30rem] overflow-hidden " >
 
      {/* Tabs Section */}
      <div className="md:hidden lg:flex gap-2 mt-5 mb-4 mx-auto lg:w-max w-[90%] bg-[#D1AF14]  text-richblack-5  p-1 lg:rounded-full rounded-lg font-medium drop-shadow-[0_1.5px_rgba(255,255,255,0.25,)]">
        {tabsName.map((ele, index) => {
          return (
            <div
              className={` text-[16px] flex flex-row items-center gap-2 ${
                currentTab === ele
                  ? "bg-richblack-900 text-richblack-5 font-medium"
                  : "text-richblack-700"
              } px-7 py-[7px] rounded-full transition-all duration-200 cursor-pointer hover:bg-richblack-900 hover:text-richblack-5`}
              key={index}
              onClick={() => setMyCards(ele)}
            >
              {ele}
            </div>
          );
        })}
      </div>
    

      {/* Cards Group */}
      <div className="lg:absolute gap-4  justify-center lg:gap-0 flex lg:justify-between flex-wrap w-[100%] mb-10 lg:-top-[40px] lg:left-[50%] lg:translate-x-[-50%] lg:translate-y-[50%] text-black lg:mb-0  lg:px-0 px-3">
        {courses.map((ele, index) => {
          return (
            <CourseCard
              key={index}
              cardData={ele}
              currentCard={currentCard}
              setCurrentCard={setCurrentCard}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ExploreMore;
